import { Component, OnInit } from '@angular/core';
import { AppNavigationService } from '../../services';

@Component({
  selector: 'app-permission-denied-page',
  templateUrl: './permission-denied-page.component.html',
  styleUrls: ['./permission-denied-page.component.scss'],
})
export class PermissionDeniedPageComponent implements OnInit {

  constructor(public appNavigationService: AppNavigationService) {}

  ngOnInit(): void {}
}
